export const STAGING_HOSTNAME = 'staging.abbeydentalsupplies.com';

/** GTM and analytics enabled on all environments (including staging for testing). */
export function isGtmEnabled(hostname?: string): boolean {
  // Enabled on all environments for testing
  return true;
}
